import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Form, Field } from "react-final-form";
import { validate } from "../data/validators/email_verification";
import Input from "../../../booking/ui/shared/components/form/Input";
import FieldContainer from "../../../booking/ui/shared/containers/form/FieldContainer";
import ErrorContainer from "../../../booking/ui/shared/containers/form/ErrorContainer";
import { NextButton } from "../../../booking/ui/shared/components/Buttons";
import { useDispatch, useSelector } from "react-redux";
import { submitEmailVerification } from '../data/account/actions/emailVerification';
import URI from 'urijs';


export default function EmailVerification() {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { email } = useSelector(state => state.account.signInModal)
    const [ selectedEmail, setSelectedEmail ] = useState("");
    const [ url, setUrl ] = useState("");
    const googleLogo = <svg width="18" height="18" viewBox="0 0 18 18"> <path d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844c-.209 1.125-.843 2.078-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" fillRule="evenodd" fillOpacity="1" fill="#4285f4" stroke="none"></path><path d="M9.003 18c2.43 0 4.467-.806 5.956-2.18L12.05 13.56c-.806.54-1.836.86-3.047.86-2.344 0-4.328-1.584-5.036-3.711H.96v2.332C2.44 15.983 5.485 18 9.003 18z" fillRule="evenodd" fillOpacity="1" fill="#34a853" stroke="none"></path><path d="M3.964 10.712c-.18-.54-.282-1.117-.282-1.71 0-.593.102-1.17.282-1.71V4.96H.957C.347 6.175 0 7.55 0 9.002c0 1.452.348 2.827.957 4.042l3.007-2.332z" fillRule="evenodd" fillOpacity="1" fill="#fbbc05" stroke="none"></path><path d="M9.003 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.464.891 11.428 0 9.002 0 5.485 0 2.44 2.017.96 4.958L3.967 7.29c.708-2.127 2.692-3.71 5.036-3.71z" fillRule="evenodd" fillOpacity="1" fill="#ea4335" stroke="none"></path></svg>

    useEffect(() => {
        setSelectedEmail(email)
        const redir = new URI(window.location.href);
        setUrl(`/api/security/googleAccount?url=${redir.path()}`);
    }, [])

    return (
        <div className={"space-y-8 flex flex-col max-w-[400px]"}>
            {/*<button onClick={()=>document.location.href=(url)} className={"flex justify-center items-center gap-2 bg-gray-100 py-2 px-4 rounded-md hover:bg-gray-200 hover:shadow-inner"}>*/}
            {/*    {googleLogo} {t('account_button.continue_with_google')}*/}
            {/*</button>*/}
            {/*<div className="flex items-center text-gray-400">*/}
            {/*    <hr className="border-gray-200 border-t flex-1" />*/}
            {/*    <p className="mx-2">{t('account_button.or_uppercase')}</p>*/}
            {/*    <hr className="border-gray-200 border-t flex-1" />*/}
            {/*</div>*/}

            <Form
                onSubmit={(values) => {
                    return (
                        dispatch(submitEmailVerification(values))
                    )
                }}
                validate={validate}
            >
                {({ handleSubmit, pristine, form, submitting, invalid, values, validating }) => {
                    return (
                        <form className="mt-8 lg:w-[400px]" onSubmit={handleSubmit}>
                            <div className={"space-y-8"}>
                                <section className="flex flex-col gap-8">
                                    <FieldContainer name="email" className="w-full">
                                        <div>
                                            <Field
                                                className="form-control"
                                                id="email"
                                                name="email"
                                                type="email"
                                                component={Input}
                                                placeholder={t('account_button.your-email')}
                                                value={selectedEmail}
                                            />
                                        </div>
                                        <ErrorContainer name="email" className="help-block" />
                                    </FieldContainer>
                                </section>
                                <FieldContainer form="sign_up" name="cgv">
                                    <ErrorContainer form="sign_up" name="cgv" />
                                </FieldContainer>
                                
                            </div>
                            <div className="flex justify-end">
                                <NextButton
                                    type="submit"
                                    disabled={pristine || submitting || invalid}
                                    loading={submitting}
                                    icon={pristine || submitting || invalid ? "ban" : "check"}
                                    className="w-full my-5 rounded-md justify-self-end"
                                >
                                    {t('account_button.next')}
                                </NextButton>
                            </div>
                        </form>
                    );
                }}
            </Form>
        </div>
    )
}